module.exports = __webpack_public_path__ + "static/media/icone-menu-relatorio.c4d59167.svg";